import { LicenseInfo } from "@mui/x-license-pro";
import * as Sentry from "@sentry/react";
// Main entry point for the app
// Sets up state store and router parents
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";

import "./index.css";
import { AuthProvider } from "store/auth/authProvider";
import App from "./App";

import * as serviceWorker from "./serviceWorker";
import "@fontsource/roboto";

// MUIX License
const muixProLicenseKey = process.env.REACT_APP_MUIX_PRO_LICENSE_KEY;
if (muixProLicenseKey) {
  LicenseInfo.setLicenseKey(muixProLicenseKey);
}

// Sentry error logging
if (process.env.REACT_APP_SENTRY_KEY) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_KEY,
    integrations: [
      new Sentry.BrowserTracing({
        tracePropagationTargets: ["localhost", /^https:\/\/claims\.my\.s12solutions\.com/],
      }),
    ],
  });
}

ReactDOM.render(
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
